import { setStorageItem } from 'app/adapters/storage';
import { clearSession } from 'app/utils/sessions';
import { setFleetEmbedInStorage } from 'app/utils/fleet-embed';

function isFleetQueryEnabled(url: URL): boolean {
  return url.searchParams.get('isFleet') === 'true';
}

/**
 * Reads `?token=` from the URL (iframe / SSO embed), stores it for Bearer auth,
 * marks the user authenticated, and strips the token from the address bar.
 *
 * When `isFleet=true` is also present (Azuga Fleet ELOGS iframe), enables fleet
 * embed mode (hide header/sidebar). Other reseller embeds omit this flag and
 * keep the full portal chrome.
 *
 * Must run synchronously before React routes render so PrivateRoute allows deep links.
 *
 * @returns `true` if a token was applied.
 */
export function bootstrapAuthTokenFromUrl(): boolean {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  const isFleet = isFleetQueryEnabled(url);

  if (!token && !isFleet) {
    return false;
  }

  let tokenApplied = false;

  if (token) {
    clearSession();

    sessionStorage.setItem('authToken', token);
    // Keep localStorage in sync for call sites that read `token` directly.
    window.localStorage.setItem('token', token);
    setStorageItem('isAuthUser', 'true');
    url.searchParams.delete('token');
    tokenApplied = true;
  }

  // Apply after clearSession so the embed flag is not wiped.
  if (isFleet) {
    setFleetEmbedInStorage(true);
    url.searchParams.delete('isFleet');
  }

  const nextSearch = url.searchParams.toString();
  const nextUrl =
    url.pathname + (nextSearch ? `?${nextSearch}` : '') + url.hash;
  window.history.replaceState({}, '', nextUrl);

  return tokenApplied;
}
